module.exports = "/365FarmNet/dist/calendar.3c21ec7f4cdc98194216084bee45f82a.html";